<template>
	<div class="modal fade" :id="modalId" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
		<div class="modal-dialog" :class="modalDialogClass">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" id="modalLabel">{{ modalTitle }}</h4>
					<button type="button" class="btn-close" @click="close()" aria-label="close"></button>
				</div>
				<slot />
			</div>
		</div>
	</div>
</template>

<script>
export default {
  	props: {
  		modalId: { type: String, default: 'modalWrapper'},
   		modalTitle: { type: String, default: ''},
   		modalDialogClass: { type: String, default: ''}
  	},
  	methods: {
  		close() {
			this.$emit("close", true)
		}
  	}
}
</script>